// extracted by mini-css-extract-plugin
module.exports = {"component":"StartScreen_component_zYcw5"};